document.addEventListener( 'DOMContentLoaded', function () {
    let elms = document.getElementsByClassName( 'gallery-thumbnail');
    let galleryItemElms = document.getElementsByClassName( 'gallery-item');
    for ( var i = 0, len = elms.length; i < len; i++ ) {
        // Create and mount the thumbnails slider.
        var thumbnailsSplide1 = new Splide( elms[ i ], {
            rewind      : true,
            fixedWidth  : 100,
            fixedHeight : 100,
            isNavigation: true,
            gap         : 0,
            focus       : 'center',
            pagination  : false,
            cover       : true,
            arrows:false,
            breakpoints : {
                '1024': {
                    fixedWidth  : 80,
                    fixedHeight : 80,
                }
                ,
                '992': {
                    fixedWidth  : 70,
                    fixedHeight : 70,
                },
                '768': {
                    fixedWidth  : 64,
                    fixedHeight : 64,
                },
                '668': {
                    fixedWidth  : 66,
                    fixedHeight : 40,
                }
            }

        } ).mount();
        // Create the main slider.
        var primarySplide1 = new Splide( galleryItemElms[i], {
            type       : 'slide',
            height: 340,
            width: 400,
            heightRatio: 1,
            pagination : false,
            arrows     : false,
            cover      : true,

        } );

        // Set the thumbnails slider as a sync target and then call mount.
        primarySplide1.sync( thumbnailsSplide1 ).mount();
    }
} );
